import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { CdkDrag, CdkDragMove, CdkDropList, CdkDropListGroup, moveItemInArray } from '@angular/cdk/drag-drop';
import {ViewportRuler} from "@angular/cdk/overlay";
import { AbstractComponent } from 'src/core/common/component/AbstractComponent';
import { GSGridService } from './GSGridService';
import { Router } from '@angular/router';

/**
 * Grid 機能の実装
 */
@Component({
  selector: 'gs-grid',
  templateUrl: './GSGrid.html',
  styleUrls: ['./GSGrid.scss'],
})
export class GSGridComponent extends AbstractComponent {

  @ViewChild('videoContainer', {static: false}) 
  public videoContainer: ElementRef;

  @ViewChild(CdkDropListGroup) 
  public listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) 
  public placeholder: CdkDropList;


  public target = null;
  public targetIndex:number;
  public source = null;
  public sourceIndex:number;
  public dragIndex:number;
  public activeContainer;

  public scope = {
    items: [],
    itemWidth : 0,
    itemHeight : 0,
    gridSize : 3,
  };

  public constructor(
    private router:Router,
    private service:GSGridService,
    private viewportRuler: ViewportRuler) {
    super();
  }
  /** 初回処理 */
  public componentWillMount() {
    this.service.get().subscribe((res:any) => {
      let items = res;
      let cameraListString = sessionStorage.getItem('camera_index');
      if (cameraListString) {
        let cameraIndex = JSON.parse(cameraListString);
        for (let camera of cameraIndex) {
          if (items.find(e => e.streamId == camera.streamId)) {
            this.scope.items.push(items.find(e => e.streamId == camera.streamId));
          }
        }
        for (let item of items) {
          if (!this.scope.items.find(e => e.streamId == item.streamId)) {
            this.scope.items.push(item);
          }
        }
      } else {
        this.scope.items = items;
      }
    });
  }
  /** */
  public componentDidMount() {
    this.scope.itemWidth = this.videoContainer.nativeElement.offsetWidth / 3;
    this.scope.itemHeight = this.scope.itemWidth * .75;
    let phElement = this.placeholder.element.nativeElement;
    phElement.style.display = 'none';
    phElement.parentElement.removeChild(phElement);
  }

  public detail(item) {
    this.router.navigate([`/camera/detail/${ item.streamId }`])
  }

  /** ドラッグ後の動き */
  public dropListDropped(e) {
    if (!this.target) {
      return;
    }

    let phElement = this.placeholder.element.nativeElement;
    let parent = phElement.parentElement;

    phElement.style.display = 'none';

    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(this.source.element.nativeElement, parent.children[this.sourceIndex]);

    this.target = null;
    this.source = null;

    if (this.sourceIndex != this.targetIndex) {

      moveItemInArray(this.scope.items, this.sourceIndex, this.targetIndex);
      sessionStorage.setItem('camera_index', JSON.stringify(this.scope.items));
    }

  }

  public dropListEnterPredicate = (drag: CdkDrag, drop: CdkDropList) => {
    if (drop == this.placeholder)
      return true;

    if (drop != this.activeContainer)
      return false;

    let phElement = this.placeholder.element.nativeElement;
    let sourceElement = drag.dropContainer.element.nativeElement;
    let dropElement = drop.element.nativeElement;

    let dragIndex = __indexOf(dropElement.parentElement.children, (this.source ? phElement : sourceElement));
    let dropIndex = __indexOf(dropElement.parentElement.children, dropElement);

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      phElement.style.width = sourceElement.clientWidth + 'px';
      phElement.style.height = sourceElement.clientHeight + 'px';
      
      sourceElement.parentElement.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = '';
    dropElement.parentElement.insertBefore(phElement, (dropIndex > dragIndex 
      ? dropElement.nextSibling : dropElement));

    this.placeholder.enter(drag, drag.element.nativeElement.offsetLeft, drag.element.nativeElement.offsetTop);
    return false;
  }

  public dragMoved(e: CdkDragMove) {
    let point = this.getPointerPositionOnPage(e.event);
    this.listGroup._items.forEach(dropList => {
      if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
        this.activeContainer = dropList;
        return;
      }
    });
  }
  public getPointerPositionOnPage(event) {
    const point = __isTouchEvent(event) ? (event.touches[0] || event.changedTouches[0]) : event;
    const scrollPosition = this.viewportRuler.getViewportScrollPosition();
    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top
    };
  }

  public gridSizeChange() {
    this.scope.itemWidth = this.videoContainer.nativeElement.offsetWidth / this.scope.gridSize;
    this.scope.itemHeight = this.scope.itemWidth * .75;
  }
  @HostListener('window:resize', ['$event'])
  public onResize(event) {
    this.gridSizeChange();
  }
}
// global
function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
};

/** Determines whether an event is a touch event. */
function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
  return event.type.startsWith('touch');
}

function __isInsideDropListClientRect(dropList: CdkDropList, x: number, y: number) {
  const {top, bottom, left, right} = dropList.element.nativeElement.getBoundingClientRect();
  return y >= top && y <= bottom && x >= left && x <= right; 
}